import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

// Token keys must match AuthContext
const ACCESS_TOKEN_KEY = 'brewflow_access_token';
const ORG_ID_KEY = 'brewflow_current_org_id';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;

// Request interceptor to add auth token and org context
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Include org ID header for explicit tenant context
    const orgId = localStorage.getItem(ORG_ID_KEY);
    if (orgId) {
      config.headers['X-Org-Id'] = orgId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const token = localStorage.getItem(ACCESS_TOKEN_KEY);
      // In demo mode, don't nuke the session - let pages handle errors gracefully
      if (token && token.startsWith('demo-')) {
        return Promise.reject(error);
      }
      // For real tokens, clear auth state and redirect
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem('brewflow_refresh_token');
      localStorage.removeItem('brewflow_token_expiry');
      localStorage.removeItem('brewflow_user_data');
      localStorage.removeItem(ORG_ID_KEY);
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
